type TFunc = (key: string) => string

export function getOfficialExampleOutputText(t: TFunc): string {
  return `<!-- === ${t('output_example_status_card_start')} === -->
<html-box>
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{{CHARACTER_NAME}} Strategy Status Card</title>
    <style>
        /* ${t('output_example_global_styles')} */
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: "Garamond", "Times New Roman", serif;
        }

        /* ${t('output_example_card_container')} */
        .strategy-card {
            max-width: 320px;
            height: 550px;
            margin: 0 auto;
            background: #f8f0e0;
            background-image:
                url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAUVBMVEWFhYWDg4N3d3dtbW17e3t1dXWBgYGHh4d5eXlzc3OLi4ubm5uVlZWPj4+NjY19fX2JiYl/f39ra2uRkZGZmZlpaWmXl5dvb29xcXGTk5NnZ2c8AAAAG3RSTlNAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEAvEOwtAAAFVklEQVR4XpWWB67c2BUFb3g557T/hRo9/WUMZHlgr4Bg8Z4qQgQJlHI4A8SzFVrapvmTF9O7dmYRFZ60YiBhJRCgh1FYhiLAmdvX0CzTOpNE77ME0Zty/nWWzchDtiqrmQDeuv3powQ5ta2eN0FY0InkqDD73lT9c9lEzwUNqgFHs9VQce3TVClFCQrSTfOiYkVJQBmpbq2L6iZavPnAPcoU0dSw0SUTqz/GtrGuXfbyyBniKykOWQWGqwwMA7QiYAxi+IlPdqo+hYHnUt5ZPfnsHJyNiDtnpJyayNBkF6cWoYGAMY92U2hXHF/C1M8uP/ZtYdiuj26UdAdQQSXQErwSOMzt/XWRWAz5GuSBIkwG1H3FabJ2OsUOUhGC6tK4EMtJO0ttC6IBD3kM0ve0tJwMdSfjZo+EEISaeTr9P3wYrGjXqyC1krcKdhMpxEnt5JetoulscpyzhXN5FRpuPHvbeQaKxFAEB6EN+cYN6xD7RYGpXpNndMmZgM5Dcs3YSNFDHUo2LGfZuukSWyUYirJAdYbF3MfqEKmjM+I2EfhA94iG3L7uKrR+GdWD73ydlIB+6hgref1QTlmgmbM3/LeX5GI1Ux1RWpgxpLuZ2+I+IjzZ8wqE4nilvQdkUdfhzI5QDWy+kw5Wgg2pGpeEVeCCA7b85BO3F9DzxB3cdqvBzWcmzbyMiqhzuYqtHRVG2y4x+KOlnyqla8AoWWpuBoYRxzXrfKuILl6SfiWCbjxoZJUaCBj1CjH7GIaDbc9kqBY3W/Rgjda1iqQcOJu2WW+76pZC9QG7M00dffe9hNnseupFL53r8F7YHSwJWUKP2q+k7RdsxyOB11n0xtOvnW4irMMFNV4H0uqwS5ExsmP9AxbDTc9JwgneAT5vTiUSm1E7BSflSt3bfa1tv8Di3R8n3Af7MNWzs49hmauE2wP+ttrq+AsWpFG2awvsuOqbipWHgtuvuaAE+A1Z/7gC9hesnr+7wqCwG8c5yAg3AL1fm8T9AZtp/bbJGwl1pNrE7RuOX7PeMRUERVaPpEs+yqeoSmuOlokqw49pgomjLeh7icHNlG19yjs6XXOMedYm5xH2YxpV2tc0Ro2jJfxC50ApuxGob7lMsxfTbeUv07TyYxpeLucEH1gNd4IKH2LAg5TdVhlCafZvpskfncCfx8pOhJzd76bJWeYFnFciwcYfubRc12Ip/ppIhA1/mSZ/RxjFDrJC5xifFjJpY2Xl5zXdguFqYyTR1zSp1Y9p+tktDYYSNflcxI0iyO4TPBdlRcpeqjK/piF5bklq77VSEaA+z8qmJTFzIWiitbnzR794USKBUaT0NTEsVjZqLaFVqJoPN9ODG70IPbfBHKK+/q/AWR0tJzYHRULOa4MP+W/HfGadZUbfw177G2j8R8+lIlydZX9g5ejfE6Zh9qAKed4RwiVgaJQFIOE3NBJqFeoG8qCDGwwIBK95q7NQDwuNu5y99v7DrYfZP7Rh7EgF4zvM3VQ+uUyrNAtuZHVGkF5S5f+c5F3yQx98Nz8kML0CkYV24ATQvVkf8f8AAAAASUVORK5CYII="),
                linear-gradient(145deg, rgba(242, 217, 170, 0.3) 0%, rgba(248, 240, 224, 0) 50%, rgba(248, 240, 224, 0.3) 100%);
            border-radius: 26px;
            border: 4px solid #946b44;
            box-shadow:
                0 10px 25px rgba(0,0,0,0.18),
                inset 0 0 0 2px #f9f1e2,
                inset 0 0 10px rgba(150, 120, 80, 0.2);
            overflow-y: auto;
            padding: 22px 18px;
            position: relative;
        }

        .strategy-card::before {
            content: "{{EMBLEM_SYMBOL}}";
            font-size: 24px;
            color: #8b0000;
            position: absolute;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            text-shadow: 2px 2px 3px rgba(0,0,0,0.1);
        }

        .strategy-card::-webkit-scrollbar { width: 7px; }
        .strategy-card::-webkit-scrollbar-track { background: #f2e9d8; border-radius: 4px; margin: 10px 0; }
        .strategy-card::-webkit-scrollbar-thumb { background: linear-gradient(180deg, #946b44 0%, #8b0000 100%); border-radius: 4px; }
        .strategy-card::-webkit-scrollbar-thumb:hover { background: linear-gradient(180deg, #8b0000 0%, #946b44 100%); }

        .card-title {
            text-align: center;
            font-size: 22px;
            font-weight: 700;
            color: #5a3e2b;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin: 8px 0 20px;
            padding-bottom: 10px;
            border-bottom: 2px dashed #b98f63;
        }

        .quote-section {
            margin-bottom: 22px;
            padding: 15px 12px;
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(248, 240, 224, 0.1) 100%);
            border-radius: 18px;
            border: 2px solid #b98f63;
            box-shadow: inset 0 0 8px rgba(0,0,0,0.05);
            position: relative;
        }
        .quote-title {
            font-size: 15px; color: #7a5438; font-weight: 700;
            margin-bottom: 10px; display: flex; align-items: center; gap: 8px;
        }
        .quote-title::after { content: ""; flex: 1; height: 1px; background: #b98f63; }
        .quote-content {
            font-size: 13px; color: #2d2418; line-height: 1.7; font-style: italic;
            margin: 6px 0; padding-left: 12px; border-left: 3px solid #8b0000;
            transition: all 0.2s ease;
        }
        .quote-content:hover { color: #8b0000; padding-left: 15px; }

        .stats-section {
            margin-bottom: 22px; padding: 15px 12px;
            background: linear-gradient(145deg, #fff8ed 0%, #f2e9d8 100%);
            border-radius: 16px; border: 3px solid #946b44;
            box-shadow: 0 3px 8px rgba(0,0,0,0.08);
        }
        .stats-title {
            font-size: 15px; color: #5a3e2b; font-weight: 700;
            margin-bottom: 12px; display: flex; align-items: center; gap: 6px;
        }
        .stats-title i { font-style: normal; color: #8b0000; }
        .stat-item {
            display: flex; justify-content: space-between; align-items: center;
            margin: 10px 0; font-size: 14px;
        }
        .stat-label { color: #7a5438; font-weight: 600; width: 70px; }
        .progress-bar {
            flex: 1; height: 14px; background: #f2e9d8;
            border-radius: 7px; border: 1px solid #d4b892;
            overflow: hidden; margin: 0 10px;
            box-shadow: inset 0 2px 3px rgba(0,0,0,0.05);
        }
        .progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #946b44 0%, #8b0000 50%, #946b44 100%);
            border-radius: 6px;
            width: {{PROGRESS_PERCENT}}%;
            animation: progressAnime 2s ease-in-out;
            box-shadow: 0 0 8px rgba(139, 0, 0, 0.3);
        }
        .hp-bar {
            flex: 1; height: 14px; background: #f2e9d8;
            border-radius: 7px; border: 1px solid #d4b892;
            overflow: hidden; margin: 0 10px;
            box-shadow: inset 0 2px 3px rgba(0,0,0,0.05);
        }
        .hp-fill {
            height: 100%;
            background: linear-gradient(90deg, #d9534f 0%, #c9302c 50%, #d9534f 100%);
            border-radius: 6px;
            width: {{HP_PERCENT}}%;
            animation: progressAnime 2s ease-in-out 0.3s;
            box-shadow: 0 0 8px rgba(217, 83, 79, 0.3);
        }
        .stat-value { color: #8b0000; font-weight: 700; min-width: 30px; text-align: right; }
        @keyframes progressAnime { 0% { width: 0; } 100% { width: var(--fill-width, {{PROGRESS_PERCENT}}%); } }

        .inventory-section {
            margin-bottom: 22px; padding: 15px 12px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 16px; border: 2px solid #b98f63;
        }
        .inventory-title {
            font-size: 15px; color: #5a3e2b; font-weight: 700;
            margin-bottom: 12px; display: flex; align-items: center; gap: 8px;
        }
        .inventory-title::before { content: "📦"; font-size: 14px; }
        .inventory-list { list-style: none; display: flex; flex-direction: column; gap: 9px; }
        .inventory-item {
            font-size: 13px; color: #2d2418; line-height: 1.6;
            padding-left: 22px; position: relative;
        }
        .inventory-item::before {
            content: "{{ITEM_SYMBOL}}"; color: #946b44; font-size: 11px;
            position: absolute; left: 0; top: 2px;
        }
        .inventory-item:hover { color: #5a3e2b; font-weight: 600; }

        .other-section {
            margin-bottom: 18px; padding: 14px 12px;
            background: linear-gradient(145deg, rgba(255, 255, 255, 0.1) 0%, rgba(248, 240, 224, 0.05) 100%);
            border-radius: 16px; border: 2px solid #b98f63;
            transition: all 0.3s ease;
        }
        .other-section:hover { box-shadow: 0 4px 10px rgba(0,0,0,0.08); transform: translateY(-2px); }
        .other-title {
            font-size: 14px; color: #8b0000; font-weight: 700;
            margin-bottom: 9px; padding-bottom: 4px; border-bottom: 1px solid #b98f63;
        }
        .other-content { font-size: 13px; color: #2d2418; line-height: 1.7; }
    </style>
</head>
<body>
    <div class="strategy-card">
        <div class="card-title">{{CHARACTER_NAME}}'s {{CARD_TYPE}} File</div>

        <div class="quote-section">
            <div class="quote-title">{{QUOTE_SECTION_TITLE}}</div>
            <div class="quote-content">{{DIALOGUE_LINE_1}}</div>
            <div class="quote-content">{{DIALOGUE_LINE_2}}</div>
            <div class="quote-content">{{DIALOGUE_LINE_3}}</div>
        </div>

        <div class="stats-section">
            <div class="stats-title"><i>{{STAT_ICON}}</i> {{STATS_SECTION_TITLE}}</div>
            <div class="stat-item">
                <span class="stat-label">{{PRIMARY_STAT_LABEL}}</span>
                <div class="progress-bar">
                    <div class="progress-fill"></div>
                </div>
                <span class="stat-value">{{PROGRESS_PERCENT}}%</span>
            </div>
            <div class="stat-item">
                <span class="stat-label">{{SECONDARY_STAT_LABEL}}</span>
                <div class="hp-bar">
                    <div class="hp-fill"></div>
                </div>
                <span class="stat-value">{{HP_PERCENT}}%</span>
            </div>
        </div>

        <div class="inventory-section">
            <div class="inventory-title">{{INVENTORY_TITLE}}</div>
            <ul class="inventory-list">
                <li class="inventory-item">{{INVENTORY_ITEM_1}}</li>
                <li class="inventory-item">{{INVENTORY_ITEM_2}}</li>
                <li class="inventory-item">{{INVENTORY_ITEM_3}}</li>
                <li class="inventory-item">{{INVENTORY_ITEM_4}}</li>
                <li class="inventory-item">{{INVENTORY_ITEM_5}}</li>
            </ul>
        </div>

        <div class="other-section">
            <div class="other-title">{{PLOT_SECTION_1_TITLE}}</div>
            <div class="other-content">
                {{PLOT_SECTION_1_CONTENT}}
            </div>
        </div>

        <div class="other-section">
            <div class="other-title">{{PLOT_SECTION_2_TITLE}}</div>
            <div class="other-content">
                {{PLOT_POINT_1}}<br>
                {{PLOT_POINT_2}}<br>
                {{PLOT_POINT_3}}
            </div>
        </div>

        <div class="other-section">
            <div class="other-title">{{PLOT_SECTION_3_TITLE}}</div>
            <div class="other-content">
                {{ANTAGONIST_1}}<br>
                {{ANTAGONIST_2}}<br>
                {{ANTAGONIST_3}}
            </div>
        </div>
    </div>
</body>
</html>
</html-box>
<!-- === ${t('output_example_status_card_end')} === -->`
}
